export interface AdminScheme {
  CoCode: string;
  SchCode: string;
  SchemeDescr: string;
  GroupDesc: string;
  CategoryCode: string;
  Phone: string;
  OEM: string;
}
